export default __webpack_public_path__ + "static/media/7.be0a768d.jpg";